import { Fragment, useState, useEffect, useRef, useCallback } from 'react';
import { Input, Radio, Button, Space, Checkbox, Form, Modal, message, Divider } from 'antd';
import { Link, useLocation, useNavigate, Outlet } from 'react-router-dom';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import './index.less';
import { arrayMoveImmutable } from 'array-move';
import addonce from '@static/images/add-once.png';
import addmore from '@static/images/add-more.png';
import addother from '@static/images/add-other.png';
import { timesaveTemplateQuestionApi, delOptionsApi } from '@services/Wj/Template';
import { timesaveSurveryQuestionApi, delSurveyOptionsApi } from '@services/Wj/Question';
import RichEditor from '@components/common/RichEditor';
import { useSurveyAutosave } from '../../SurveyAutosaveContext';
import { applyQuestionStemFocusBorder, clearQuestionStemFocusBorder } from '../richEditorFocusHelpers';
import { useQuestionStemAutosave } from '../useQuestionStemAutosave';
import { saveQuestionStemBody } from '../saveQuestionStemBody';

const SortItem = ({ questionId, type, item, setAnserArea, anserArea, onReset }) => {
    const { notifySaved } = useSurveyAutosave();
    const [modal, contextHolder] = Modal.useModal();
    const [choiceList, setChoiceList] = useState([]);
    const [moreOpen, setMoreOpen] = useState(false);
    const [questionIndex, setQuestionIndex] = useState();
    const [otherMore, setOtherMore] = useState([]);
    const [titleBorder, setTitleBorder] = useState(false);
    const [remark, setRemark] = useState(false);
    const [titleIn, setTitleIn] = useState(false);
    const [bodyHtml, setBodyHtml] = useState(item.body);
    const [form] = Form.useForm();
    const { TextArea } = Input;
    const editorRootRef = useRef(null);
    const location = useLocation();
    const { pathname } = location;
    const anserAreaRef = useRef(anserArea);

    useEffect(() => {
        anserAreaRef.current = anserArea;
    }, [anserArea]);

    useEffect(() => {
        setBodyHtml(item.body);
    }, [item.body]);

    //题目题号
    useEffect(() => {
        const index = anserArea.findIndex(it => it.id === item.id);
        setQuestionIndex(index + 1);
    }, [anserArea, item.id]);

    //选项排序
    const onSortEnd = ({ oldIndex, newIndex }) => {
        var sortArr = arrayMoveImmutable(choiceList, oldIndex, newIndex);
        setChoiceList([...sortArr]);
        saveOpinion(sortArr);
    };

    //设置选项中是否包含其他
    useEffect(() => {
        setChoiceList([...(item.options || [])]);
        if ((item.options || []).every(it => it.isBlank === 0 || it.isBlank === null)) {
            setRemark(false);
        } else {
            setRemark(true);
        }
    }, [item.options]);

    //删除选项
    const deleteRadio = (item, content) => {
        const arr = choiceList.filter(it => it.isBlank === 0);
        if (arr.length <= 2) {
            message.error('不可以再删除了!');
            return;
        } else {
            Modal.confirm({
                title: '提示',
                content: `确认删除选项${content}`,
                okText: '确定',
                cancelText: '取消',
                onOk: () => {
                    if (location.state.route === 'newCreate') {
                        delOptionsApi({ id: item }).then(res => {
                            if (res.status_code === 200) {
                                onReset();
                            }
                        });
                    } else if (location.state.route === 'newList' || location.state?.route === 'newTemplate') {
                        delSurveyOptionsApi({ id: item }).then(res => {
                            if (res.status_code === 200) {
                                onReset();
                            }
                        });
                    }
                    setChoiceList([...choiceList]);
                },
            });
        }
    };

    // 添加其他
    const addRemark = () => {
        setRemark(true);
        const addList = [...choiceList];
        addList[addList.length] = { content: '其他', isBlank: 1 };
        setChoiceList([...addList]);
        saveOpinion(addList);
    };
    // // 删除其他
    const deleteRemark = () => {
        setRemark(false);
        console.log(choiceList);
        const delOther = choiceList.find(it => it.isBlank === 1);
        if (location.state.route === 'newCreate') {
            delOptionsApi({ id: delOther.id }).then(res => {
                if (res.status_code === 200) {
                    onReset();
                }
            });
        } else if (location.state.route === 'newList' || location.state?.route === 'newTemplate') {
            delSurveyOptionsApi({ id: delOther.id }).then(res => {
                if (res.status_code === 200) {
                    onReset();
                }
            });
        }
    };
    //批量添加modal
    const addMore = () => {
        setMoreOpen(true);
    };
    const onPersist = useCallback(
        async nextBody => {
            const ok = await saveQuestionStemBody({
                item,
                nextBody,
                anserArea: anserAreaRef.current,
                locationState: location.state,
                pathname,
            });
            if (ok) {
                notifySaved();
            }
            return ok;
        },
        [item, location.state, pathname, notifySaved],
    );

    const { schedule, flush } = useQuestionStemAutosave({
        itemId: item.id,
        remoteBody: item.body,
        onPersist,
    });

    const handleStemChange = useCallback(
        html => {
            setBodyHtml(html);
            schedule(html);
        },
        [schedule],
    );

    // 修改标题（blur 时落库，与防抖合并为单次请求）
    const changeTitle = (_editor, latestHtml) => {
        const nextBody = latestHtml != null ? latestHtml : bodyHtml;
        const root = editorRootRef.current;
        if (root) {
            clearQuestionStemFocusBorder(root);
        }
        setBodyHtml(nextBody);
        setTitleBorder(false);
        flush(nextBody);
    };
    //触碰显示边框
    const getBorder = () => {
        const root = editorRootRef.current;
        if (root) {
            applyQuestionStemFocusBorder(root);
        }
        setTitleBorder(true);
        setTitleIn(true);
    };
    //改变选项内容
    const changeOpinion = (e, it) => {
        it.content = e.target.value;
        setChoiceList([...choiceList]);
        console.log(it, item);
        saveOpinion();
    };
    //保存选项
    const saveOpinion = sortArr => {
        const resArr = [...anserArea];
        const index = resArr.findIndex(it => it.id === item.id);
        resArr[index] = {
            ...resArr[index],
            templateId: location.state.id,
            options: sortArr || choiceList,
        };
        console.log(resArr[index]);
        if (location.state.route === 'newCreate') {
            timesaveTemplateQuestionApi(resArr[index]).then(res => {
                if (res.status_code === 200) {
                    notifySaved();
                }
            });
        } else if (location.state.route === 'newList' || location.state?.route === 'newTemplate') {
            timesaveSurveryQuestionApi(resArr[index]).then(res => {
                if (res.status_code === 200) {
                    notifySaved();
                    onReset();
                }
            });
        }
        setAnserArea(resArr);
    };
    //添加选项
    const addChoice = () => {
        let id = choiceList[choiceList.length - 1].id;
        id++;
        const addList = [...choiceList, { content: '选项', isBlank: 0 }];
        setChoiceList([...addList]);
        saveOpinion(addList);
    };
    //关闭批量添添加modal
    const onCancel = () => {
        setMoreOpen(false);
        form.resetFields();
        setOtherMore([]);
    };
    //批量添加完成
    const onOk = () => {
        const resOld = [...choiceList];
        const str = form.getFieldsValue().opinion + '';
        if (!str) {
            message.info('未输入内容');
            return;
        }
        if (str === 'undefined') {
            message.info('未输入内容');
            return;
        }
        const arr = str.split('\n');
        const bool = true,
            index = 0,
            newArr = [];
        arr.forEach((item, ind) => {
            if (!bool) return;
            if (!item) return;
            newArr.push(item);
        });
        const filArr = arr.filter(it => it !== '');
        // setMoreOpen(false)
        const final = filArr.map(item => {
            return {
                content: item,
                isBlank: 0,
            };
        });
        const resArr = resOld.concat(final);
        saveOpinion(resArr);
    };

    const SortableMain = SortableContainer(({ children }) => {
        return <ul>{children}</ul>;
    });
    const SortableItem = SortableElement(({ item, num }) => (
        <li>
            <Checkbox key={item.id} className="options-item" disabled>
                <TextArea
                    className="option-item"
                    placeholder={`选项`}
                    defaultValue={item.content}
                    onBlur={e => changeOpinion(e, item)}
                    variant="borderless"
                    maxLength={200}
                    autoSize={{
                        minRows: 1,
                    }}
                ></TextArea>
                <div className="opion-action">
                    <DragHandle />
                    <span
                        className="anticon del-opinion"
                        onClick={() => {
                            deleteRadio(item.id, item.content);
                        }}
                    >
                        <i className="bi bi-x"></i>
                    </span>
                </div>
            </Checkbox>
        </li>
    ));
    const DragHandle = SortableHandle(() => <i className="bi bi-grip-vertical"></i>);

    return (
        <Fragment>
            <div name={questionId}>
                <div className="question-title">
                    <div className="question-id">
                        <span className="required" style={{ display: item.required === 1 ? '' : 'none' }}>
                            *
                        </span>
                        <b className="question-index">{questionIndex}.</b>
                    </div>
                    {/* <TextArea
                        className='question-title-area'
                        placeholder='请输入问题'
                        defaultValue={item.body}
                        onFocus={getBorder}
                        onBlur={(e) => changeTitle(e)}
                        variant={titleBorder ? 'outlined' : 'borderless'}
                        style={{border:titleIn ? '1px solid #1a73e8':''}}
                        maxLength={200}
                        autoSize={{
                            minRows: 1,
                        }}
                    >
                    </TextArea> */}
                    <div ref={editorRootRef}>
                        <RichEditor id={`wj-sort-question-${item.id}`} mode="simple" inline value={bodyHtml} onChange={handleStemChange} placeholder="请输入问题" className="question-title-area" height={128} onEditorFocus={getBorder} onEditorBlur={changeTitle} />
                    </div>
                </div>
                <div>
                    <Checkbox.Group style={{ display: 'block' }}>
                        <SortableMain onSortEnd={onSortEnd} distance={10}>
                            {choiceList
                                .filter(item => item.isBlank === 0)
                                .map((item, index) => (
                                    <SortableItem key={`item-${item.id}`} index={index} item={item} num={index} />
                                ))}
                        </SortableMain>
                    </Checkbox.Group>
                    <div className="choice-action">
                        <Button type="link" onClick={addChoice}>
                            <img className="icon-width" src={addonce} />
                            添加选项
                        </Button>
                        <Button type="link" onClick={addMore}>
                            <img className="icon-width" src={addmore} />
                            批量添加选项
                        </Button>
                    </div>
                </div>
            </div>

            <Modal title={'批量添加选项'} open={moreOpen} onCancel={onCancel} onOk={onOk}>
                <Form form={form} className="add_other">
                    <p>每行代表一个选项，点击回车键换行</p>
                    <Form.Item name="opinion">
                        <TextArea
                            className="vertical-scrollbar"
                            autoSize={{
                                minRows: 6,
                                maxRows: 6,
                            }}
                        ></TextArea>
                    </Form.Item>
                </Form>
            </Modal>
        </Fragment>
    );
};

export default SortItem;
